import useChatRestClient from '@/Api/ChatRestClient';
import {useMutation} from '@tanstack/react-query';

export default function useMentorCallRequest(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const ChatRestClient = useChatRestClient();
  type MentorCallRequestResponse = {
    success: boolean;
    [key: string]: any;
  };

  const mutation = useMutation<MentorCallRequestResponse>(
    async payload => {
      const response = await ChatRestClient.post(
        'subscription/v1/mentor-call-request',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess && data?.success) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
